import React from 'react';
import UserForm from './UserForm';

export default function AddUser() {
  return <UserForm />;
}
